import _ from "lodash";
import jwtDecode from "jwt-decode";
import { getCookie, getLocalStorage, setLocalStorage, clearLocalStorageOnLogout } from "./common";
import { USER_INFO_KEY, USER_TYPE_AGENT } from "../constants/common";
import { convertToNumber } from "./validations";
import { apiCall } from "../services/v2/apiService";
import { tokenRefresh } from "../services/v2/loginService";
import { GET_USER_DETAILS } from "../constants/v2/endPoints";



export const updateUserDetailsToStorage = (userResponse, provider = null, userPreference = null, mlsName = null, location = null) => {

  const resResult = _.get(userResponse, "result", null);
  const userResult = _.get(resResult, "user", null);
  const userSession = _.get(resResult, "userSession", "");
  const refreshToken = _.get(resResult, "refreshToken", "");
  const firstName = _.get(userResult, "FirstName", "") || "";
  const lastName = _.get(userResult, "LastName", "") || "";
  const name = firstName + " " + lastName;
  const tutorialStatus = _.get(resResult, "tutorialStatus", "");
  const userTypeId = _.get(userResult, "UserTypeId", "");
  const mls = _.get(userResult, "mls", "") || mlsName;

  if (userSession) {
    const userDetails = {
      token: {
        accessToken: userSession,
        refreshToken: refreshToken,
        providerLogin: provider ? provider : false,
      },
      userInfo: {
        userId: _.get(userResult, "UserId", ""),
        email: _.get(userResult, "Email", ""),
        name: name,
        firstName: firstName,
        lastName: lastName,
        userIsVerified: _.get(userResult, "IsVerified", ""),
        userEmailVerified: _.get(userResult, "IsEmailVerified", ""),
        planStatus: _.get(userResult, "PlanStatus", ""),
        userStatus: _.get(userResult, "UserStatus", ""),
        userType: userTypeId,
        userPreference: userPreference,
        image: _.get(userResult, "Image", ""),
        location,
        mls,
      },
    };

    if (convertToNumber(userTypeId === USER_TYPE_AGENT)) {
      const agentTitle = _.get(userResult, "Agent_Title", "");
      userDetails.userInfo.agentTitle = agentTitle;
    }

    setLocalStorage(USER_INFO_KEY, userDetails);

    if (tutorialStatus && tutorialStatus.length) {
      let tutorialDisplayedPages = [];
      for (let i = 0; i < tutorialStatus.length; i++) {
        if (
          tutorialStatus[i].PageNo &&
          tutorialStatus[i].Status == 1 &&
          !tutorialDisplayedPages.includes(tutorialStatus[i].PageNo)
        ) {
          tutorialDisplayedPages.push(tutorialStatus[i].PageNo);
        }
      }
      setLocalStorage("tutorialDisplayedPages", tutorialDisplayedPages);
    }
  }
};
